import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import {
  IconChevronDown,
  IconChevronUp,
  IconGripVertical,
  IconLanguage,
  IconTrash,
} from "@tabler/icons-react";
import {
  DEFAULT_SECTION_ICON,
  TOUR_SECTION_ICON_OPTIONS,
} from "./constants";

function SortableSectionCard({
  section,
  visibleLanguageIso,
  isOpen,
  children,
  onToggle,
  onTranslate,
  onDelete,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: section.id,
    });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };
  const sectionTitle =
    section?.title?.[visibleLanguageIso] ||
    section?.title?.en ||
    `Section ${section.order}`;
  const SectionIcon =
    TOUR_SECTION_ICON_OPTIONS.find((option) => option.value === section?.iconName)
      ?.Icon || DEFAULT_SECTION_ICON;

  return (
    <article ref={setNodeRef} style={style} className="before-you-go-tool-item">
      <div className="before-you-go-tool-item-head">
        <button
          type="button"
          className="before-you-go-tool-drag"
          aria-label="Reorder section"
          title="Reorder section"
          {...attributes}
          {...listeners}
        >
          <IconGripVertical size={16} />
        </button>
        <button
          type="button"
          className="before-you-go-tool-accordion"
          onClick={onToggle}
        >
          <span className="before-you-go-tool-order">
            <SectionIcon size={16} />
          </span>
          <span>{sectionTitle}</span>
          {isOpen ? <IconChevronUp size={16} /> : <IconChevronDown size={16} />}
        </button>
        {onTranslate ? (
          <button
            type="button"
            className="app-icon-btn app-icon-btn--update"
            aria-label={`Translate ${sectionTitle}`}
            title={`Translate ${sectionTitle}`}
            onClick={(event) => {
              event.stopPropagation();
              onTranslate();
            }}
          >
            <IconLanguage size={16} />
          </button>
        ) : null}
        <button
          type="button"
          className="app-icon-btn app-icon-btn--delete"
          aria-label="Delete section"
          title="Delete section"
          onClick={onDelete}
        >
          <IconTrash size={16} />
        </button>
      </div>
      {children}
    </article>
  );
}

export default SortableSectionCard;
